module.exports = __webpack_public_path__ + "static/media/home-hero--bg-southkorea.5e639b59.jpg";